<template>
<v-select ref="list" @focus='passEvent' :loading="loading" :value="value" :items="items" item-text="title" item-value="_id" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)" @change="v => $emit('input', v)"
  no-data-text="اطلاعاتی موجود نیست...">
</v-select>
</template>

<script>
//
import myAxios from '../functions/myAxios'

//   :class="{'v-input--is-focused primary--text' : filtered.length}"
// :menu-props="{ maxHeight: 50 }"
export default {
  name: 'MyProducts',
  props: {
    value: {
      // type: String,
      required: true,
    },
    refs: {
      type: Boolean
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async retrieveData() {
      //
      this.loading = true
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/products/name`,
        });
        if (res && res.data) {
          // console.log(res);
          let title = res.data.map(function(item) {
            return {
              _id: item._id,
              title: `${item.id} - ${item.title}`,
            }
          })
          this.items = title
          this.loading = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    passEvent() {
      if (this.items && this.items.length) {
        this.$emit('setDefaultValue', this.items[0])
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
  mounted() {
    if (this.refs === true) {
      this.$refs.list.focus()
    }
  },
}
</script>
<style lang="scss" scoped>
// .v-autocomplete-content .v-select-list .v-subheader {
//     color: red;
// }
</style>
